module.exports = __webpack_public_path__ + "img/phone.f5d84b00.svg";